module.exports = __webpack_public_path__ + "img/male_03.5df16305.png";